import { AnyAction, PayloadAction } from "@reduxjs/toolkit";
import { ReduxHelper } from "helpers";
import { IBaseReducerState } from "helpers/reduxHelpers";
import { AppConfigActions } from "redux/actions";
interface IAppState extends IBaseReducerState {
  currentAction: string;
  downloading: boolean;
}

const initialState: IAppState = {
  currentAction: "APP",
  downloading: false,
  action: AppConfigActions.prefix,
  prefix: AppConfigActions.prefix,
};

const clearCurrentAction = (state: IAppState, action: PayloadAction) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.action = AppConfigActions.prefix;
  });

const reducer = ReduxHelper.createHandleReducer(initialState, (builder) => {
  builder
    .addCase(AppConfigActions.clearAction.request, clearCurrentAction)
    .addMatcher(
      () => true,
      (state, action: any) => {
        state.currentAction = action.type;

        if (action?.type?.includes("DOWNLOAD")) {
          switch (true) {
            case action?.type?.includes("REQUEST"):
              state.downloading = true;
              break;
            case action?.type?.includes("SUCCESS") ||
              action?.type?.includes("FAILED"):
              state.downloading = false;
              break;
          }
        }
      }
    );
});

export default reducer;
